export default {
  buttons: {
    done: 'Fertig',
  },
};
